import * as React from 'react';
import { useIntl } from 'react-intl';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import styled from '@mui/material/styles/styled';
import NutritionSummary from './NutritionSummary';

const SummaryTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
}));

export interface NutritionSummaryTabsProps {
  nutritionValues: Record<string, {
    water: number;
    calories: number;
    carbs: number;
    protein: number;
    fat: number;
    sodium: number;
    caffeine: number;
  }>;
  tabs: Array<{ value: string; labelId: string }>;
  defaultTab?: string;
}

const NutritionSummaryTabs: React.FC<NutritionSummaryTabsProps> = ({
  nutritionValues,
  tabs,
  defaultTab
}) => {
  const intl = useIntl();
  const [tab, setTab] = React.useState<string>(defaultTab || tabs[0]?.value || '');

  return (
    <>
      <Box textAlign="center" marginY={1}>
        <Typography variant="body2" fontWeight="bold">
          {intl.formatMessage({ id: "plans.nutritionSummary" })}
        </Typography>
      </Box>
      <Divider />

      <Tabs
        value={tab}
        onChange={(ev, value) => setTab(value)}
        variant="fullWidth"
      >
        {tabs.map((tabItem) => (
          <SummaryTab
            key={tabItem.value}
            value={tabItem.value}
            label={intl.formatMessage({ id: tabItem.labelId })}
          />
        ))}
      </Tabs>

      <NutritionSummary nutritionValues={nutritionValues[tab]} />
    </>
  );
};

export default NutritionSummaryTabs;
